'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["scrollElementRef"];
import { forwardRef, useRef } from 'react';
import getComponentName from 'react-utils/getComponentName';
import { attachWrappedComponent } from './utils';
import refObject from '../utils/propTypes/refObject';
import { jsx as _jsx } from "react/jsx-runtime";
export default function (Component) {
  const ShareScrollElementComponent = /*#__PURE__*/forwardRef((props, ref) => {
    const {
        scrollElementRef
      } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);
    const defaultRef = useRef(null);
    return /*#__PURE__*/_jsx(Component, Object.assign({}, rest, {
      scrollElementRef: scrollElementRef || defaultRef,
      ref: ref
    }));
  });
  const componentName = getComponentName(Component);
  ShareScrollElementComponent.displayName = `ShareScrollElement(${componentName})`;
  ShareScrollElementComponent.propTypes = Object.assign({}, Component.propTypes, {
    scrollElementRef: refObject
  });
  /* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
  ShareScrollElementComponent.defaultProps = Component.defaultProps;
  attachWrappedComponent(ShareScrollElementComponent, Component);
  return ShareScrollElementComponent;
}